import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

// Only the selected record ID is sent to the API; names here are display-only.
export default function AssetStaffSelector({ value, name, onChange }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setResults([]); setError("");
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/assets/staff-options", { params: { q: query } });
        if (active) setResults(data);
      } catch (e) { if (active) setError(formatApiError(e)); }
      finally { if (active) setLoading(false); }
    }, 250);
    return () => { active = false; clearTimeout(timer); };
  }, [query]);
  return <div className="space-y-2">
    <p className="text-sm" data-testid="selected-asset-staff">{name || (value ? "Selected staff" : "Unassigned / No assigned staff")}</p>
    <Input aria-label="Search assigned staff" placeholder="Search staff by name..." value={query} onChange={e => setQuery(e.target.value)} data-testid="asset-staff-search" />
    <Button type="button" variant="outline" onClick={() => { setQuery(""); onChange("", ""); }} data-testid="asset-staff-unassigned">Unassigned / No assigned staff</Button>
    {loading && <p role="status" className="text-xs">Searching staff...</p>}
    {error && <p role="alert" className="text-xs text-red-700">{error}</p>}
    <div role="listbox" aria-label="Matching staff" className="max-h-40 overflow-y-auto">
      {results.map(staff => <button type="button" role="option" aria-selected={value === staff.id} key={staff.id} className="block w-full rounded p-2 text-left text-sm hover:bg-slate-100" onClick={() => { onChange(staff.id, staff.full_name); setQuery(""); }}>{staff.full_name}</button>)}
    </div>
    {!loading && !error && query && results.length === 0 && <p className="text-xs">No matching staff.</p>}
  </div>;
}
